module.exports = __webpack_public_path__ + "img/icon_de_bg.46506ef9.png";